import React from 'react'
import styles from './BlogNav.module.css';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import YouTubeIcon from '@material-ui/icons/YouTube';
import CallToActionIcon from '@material-ui/icons/CallToAction';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import PublicIcon from '@material-ui/icons/Public';
import WifiIcon from '@material-ui/icons/Wifi';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import { Button } from '@material-ui/core';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
const BlogNav = ({name}) => {
    return (
        <div className={styles.blognav}>
            <div className={styles.userblog}>
                <div className={styles.blogtext}>
                    <h2>{name} Blog</h2>
                </div>
                <div className={styles.blogbutton}>
                    <SearchIcon className={styles.blogbutton_upper} />
                    <Brightness4Icon className={styles.blogbutton_upper}/>
                    
                    <Button style={{ color: "black", background: "white" }} variant="outlined"><AddIcon/>Follow</Button>
                    <KeyboardArrowDownIcon className={styles.blogbutton_up}/>
                </div>
            </div>
            <div className={styles.bloghome}>
                <div>
                    <ul className={styles.ullist}>
                        <li>HOME</li>
                        <li>DONATE</li>
                        <li>YOUTUBE</li>
                        <li>CONTACT</li>
                        <li>ABOUT</li>
                        <li>SERIES</li>
                        <li>BADGES</li>
                    </ul>
                </div>
                <div className={styles.icons_right}>
                    <ul className={styles.ullist_right}>
                        <TwitterIcon className={styles.ullist_right_icon} />
                        <GitHubIcon className={styles.ullist_right_icon}/>
                        <YouTubeIcon className={styles.ullist_right_icon}/>
                        <CallToActionIcon className={styles.ullist_right_icon}/>
                        <LinkedInIcon className={styles.ullist_right_icon}/>
                        <PublicIcon className={styles.ullist_right_icon}/>
                        <WifiIcon className={styles.ullist_right_icon}/>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default BlogNav
